import axios from "axios";

const isLocalHost =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

const defaultBaseUrl = isLocalHost
  ? "http://localhost:5001"
  : "https://api.customersupports24x7.in";

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || defaultBaseUrl;

export const adminApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 45000,
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
